import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import slides from "../data/slides";

function Banner() {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-[75vh] md:min-h-[90vh] flex items-center justify-center text-center pt-[90px] overflow-hidden bg-[#0B1220]"
    >
      {/* Background Slider */}
      {slides.map((slide, i) => (
        <motion.img
          key={i}
          src={slide.img}
          alt="slide"
          className="absolute inset-0 w-full h-full object-cover"
          initial={{ opacity: 0, scale: 1.1 }}
          animate={{
            opacity: i === index ? 1 : 0,
            scale: i === index ? 1 : 1.1,
          }}
          transition={{ duration: 1.2 }}
        />
      ))}

      {/* Overlay */}
      <motion.div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(110deg, rgba(5,10,20,0.96), rgba(5,10,20,0.9), rgba(5,10,20,0.8))",
          backgroundSize: "200% 200%",
        }}
        animate={{
          backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
        }}
        transition={{
          duration: 12,
          ease: "easeInOut",
          repeat: Infinity,
        }}
      />

      {/* Content */}
      <div className="relative max-w-5xl mx-auto px-4 text-white w-full flex flex-col items-center">
        <div className="max-w-3xl text-center">

          {/* Tag */}
          <motion.p
            key={index + "tag"}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-[#b31159] text-xs sm:text-sm font-semibold tracking-wide mb-5"
          >
            TRUSTED IT & HARDWARE PARTNER
          </motion.p>

          {/* Heading */}
          <motion.h1
            key={index + "title"}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="font-bold leading-tight my-8
            text-2xl 
            sm:text-3xl 
            md:text-4xl 
            lg:text-5xl 
            xl:text-6xl 
            drop-shadow-lg"
          >
            {slides[index].title}
          </motion.h1>

          {/* Description */}
          <motion.p
            key={index + "desc"}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="mt-4 text-gray-200 
            text-sm 
            sm:text-base 
            md:text-lg 
            drop-shadow-md lg:mb-10"
          >
            {slides[index].desc}
          </motion.p>

          {/* Buttons */}
          <div className="my-8 flex flex-col sm:flex-row gap-4 justify-center items-center">
          
          <a href="#contact" className="relative px-6 py-3 rounded-lg overflow-hidden border border-white/30 text-white font-medium group">

          {/* Animated gradient */}
          <span className="pause-on-hover absolute inset-0 bg-gradient-to-r from-[#b31159] via-purple-600 to-[#b31159] animate-[slide_3s_linear_infinite]"></span>

          {/* Glow */}
          <span className="pause-on-hover absolute inset-0 blur-md bg-[#b31159]/40 opacity-60 animate-pulse"></span>

          {/* Content */}
          <span className="relative z-10 flex items-center gap-2">
            Get Free Consultation

            {/* Arrow */}
            <span className="pause-on-hover inline-block animate-[arrowMove_1s_ease-in-out_infinite]">
              →
            </span>
          </span>
          </a>
          </div>

          {/* Dots */}
          <div className="mt-8 flex gap-2 justify-center py-8">
            {slides.map((_, i) => (
              <button
                key={i}
                onClick={() => setIndex(i)}
                className={`w-3 h-3 rounded-full transition ${
                  i === index ? "bg-[#b31159]" : "bg-white"
                }`}
              />
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}

export default Banner;